'use client';

import { BrandedSearchBlock } from '@/types/contentStack';
import { BrandedSearchCLPUI } from '@nxt-costco-com/forge-digital-components';

export function BrandedSearch({ entry }: { entry: BrandedSearchBlock }) {
    if (!entry.branded_search) {
        return null;
    }
    const handleBrandedSearchSubmit = (keyword: string) => {
        const url = new URL(window.location.href);
        const searchParams = new URLSearchParams(url.search ?? '');
        searchParams.set('keyword', keyword);
        url.search = searchParams.toString();

        window.location.assign(url.toString());
    };

    return (
        <BrandedSearchCLPUI
            data={entry.branded_search}
            onClickHandler={handleBrandedSearchSubmit}
        />
    );
}
